export const TILE_VERSIONS = [
  { value: "2026v1", label: "2026 v1.0" },
  { value: "2025v2", label: "2025 v2.0" },
  { value: "2025v1r1", label: "2025 v1.1" },
  { value: "2025v1", label: "2025 v1.0" },
];
